import ReactDOM from 'react-dom/client'
import './index.css'
import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClientProvider } from '@tanstack/react-query'
import React, { StrictMode } from 'react'
import { PreviewBadge } from '@/components/PreviewBadge'
import { queryClient } from '@/lib/queryClient'
import { LogRocketService } from '@/services/logrocket'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { MixpanelService } from './services/mixpanel/mixpanelService'

if (import.meta.env.VITE_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: import.meta.env.VITE_APP_ENV || 'development',
    onError: (event) => {
      const message = event.errors?.[0]?.errorMessage || ''
      const errorClass = event.errors?.[0]?.errorClass || ''

      // Filter out browser extension errors (password managers, etc.)
      // These throw non-Error values when interacting with form fields
      if (
        message.includes('Object Not Found Matching Id') ||
        message.includes('MethodName:') ||
        errorClass === 'InvalidError'
      ) {
        return false
      }
    },
  })

  BugsnagPerformance.start({ apiKey: import.meta.env.VITE_BUGSNAG_API_KEY })
} else {
  console.error('Bugsnag failed to initialize')
}

const mixpanelService = new MixpanelService()

mixpanelService.init()

const logRocketService = new LogRocketService()

logRocketService.init()

const ReactBugsnag = import.meta.env.VITE_BUGSNAG_API_KEY
  ? Bugsnag.getPlugin('react')
  : null
const ErrorBoundary = ReactBugsnag?.createErrorBoundary(React) || React.Fragment

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <ErrorBoundary>
      <GoogleOAuthProvider
        clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''}
      >
        <QueryClientProvider client={queryClient}>
          <App />
          <PreviewBadge />
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
